interface WaveformIconProps {
  className?: string
  width?: number
  height?: number
}

export function WaveformIcon({
  className = "text-white",
  width = 16,
  height = 16,
}: WaveformIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="2" y="8" width="1.5" height="3" fill="currentColor" />
      <rect x="5" y="6" width="1.5" height="7" fill="currentColor" />
      <rect x="8" y="4" width="1.5" height="11" fill="currentColor" />
      <rect x="11" y="7" width="1.5" height="5" fill="currentColor" />
      <rect x="13.5" y="9" width="1.5" height="3" fill="currentColor" />
    </svg>
  )
}
